import { render, staticRenderFns } from "./ShainExpDetails.vue?vue&type=template&id=40bb83a8&scoped=true"
import script from "./ShainExpDetails.vue?vue&type=script&lang=js"
export * from "./ShainExpDetails.vue?vue&type=script&lang=js"
import style0 from "./ShainExpDetails.vue?vue&type=style&index=0&id=40bb83a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb83a8",
  null
  
)

export default component.exports